import settings from './settings';

let entityManager: breeze.EntityManager;

export async function createEntityManagerAsync() {

  breeze.config.initializeAdapterInstance('uriBuilder', 'json');
  breeze.NamingConvention.camelCase.setAsDefault();

  if (entityManager) {
    return Promise.resolve(copyEntityManager());
  }

  entityManager = new breeze.EntityManager(settings.serviceName);

  return entityManager.fetchMetadata()
    .then(() => copyEntityManager());
}

export function getEntityManager() {
  return entityManager;
}

export function setBreezeHeaders(token: string) {

  // get the current default Breeze ajax adapter
  const adapter: any = breeze.config.getAdapterInstance('ajax');

  // set antiForgery header
  adapter.requestInterceptor = function (requestInfo: any) {
    //requestInfo.config.headers['x-csrf-token-header-cpt'] = token;
    requestInfo.config.headers['x-csrf-token-header-cpt-sso'] = token;
    // this tells .NET Core to not do a forms auth redirect to login page
    requestInfo.config.headers['X-Requested-With'] = 'XMLHttpRequest';
    requestInfo.config.headers['Cache-Control'] = 'no-cache';

    if (requestInfo.config.url.indexOf('Metadata') > -1) {
      requestInfo.config.url += `/ts/${Date.now()}`;
    }

  };

  // set antiForgery header
  // adapter.defaultSettings = {
    // headers: {
      // 'x-csrf-token-header-cpt': token,
    // },
  // };

}

const eventCtor = function () {};

function eventInitialiser(event: any) {
  event.testComputed = `${event.name} - computed`;
}

function extendMetadata(metadataStore:breeze.MetadataStore) {
  metadataStore.registerEntityTypeCtor('Event', eventCtor, eventInitialiser);
  return true;
}

function copyEntityManager() {
  // extendMetadata(entityManager.metadataStore);
  const copy: breeze.EntityManager = entityManager.createEmptyCopy();
  copy.entityChanged.subscribe(logChanges);
  // entityManager.importEntities(entityManager.exportEntities());
  return copy;
}

// log entity changes to the console for debugging purposes.
function logChanges(data:
  {
    entity:
    {
      entityType:
      {
        name: string;
      };
      entityAspect:
      {
        getKey: () =>
          {
            toString: () => string;
          };
        entityState:
        {
          getName: () => string;
        };
      };
    };
    entityAction: breeze.EntityActionSymbol; args: any;
  }) {
  const entityName: string = data.entity ?
    `${data.entity.entityType.name}'/'${data.entity.entityAspect.getKey().toString()}` :
    '?';
  let message = `Entity Changed. Entity: ${entityName};
  EntityAction: ${data.entityAction.getName()} ;`;
  if (data.entityAction === breeze.EntityAction.PropertyChange) {
    const pcArgs = data.args;
    message += `PropertyName: ${(pcArgs.propertyName || 'null')};
    Old Value: ${(pcArgs.oldValue ? pcArgs.oldValue.toString() : 'null')};
    New Value: ' ${(pcArgs.newValue ? pcArgs.newValue.toString() : 'null')};`;
  }
  if (data.entityAction === breeze.EntityAction.EntityStateChange) {
    message += `New State: ${data.entity.entityAspect.entityState.getName()};`;
  }
  console.log(message);
}
